//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'kov_01',
    colors: ['#d24c23', '#7ba6bc', '#f0c667', '#ede2b3', '#672b35', '#142a36'],
    stroke: '#132a37',
    background: '#108266',
    type: 'kovesecs',
  },
  {
    name: 'kov_02',
    colors: ['#e8dccc', '#e94641', '#eeaeae'],
    stroke: '#e8dccc',
    background: '#6c96be',
    type: 'kovesecs',
  },
  {
    name: 'kov_03',
    colors: ['#e3937b', '#d93f1d', '#090d15', '#e6cca7'],
    stroke: '#090d15',
    background: '#558947',
    type: 'kovesecs',
  },
  {
    name: 'kov_04',
    colors: ['#d03718', '#292b36', '#33762f', '#ead7c9', '#ce7028', '#689d8d'],
    stroke: '#292b36',
    background: '#deb330',
    type: 'kovesecs',
  },
  {
    name: 'kov_05',
    colors: ['#de3f1a', '#de9232', '#007158', '#e6cdaf', '#869679'],
    stroke: '#010006',
    background: '#7aa5a6',
    type: 'kovesecs',
  },
  {
    name: 'kov_06',
    colors: ['#a87c2a', '#bdc9b1', '#f14616', '#ecbfaf', '#017724', '#0e2733', '#2b9ae9'],
    stroke: '#292319',
    background: '#dfd4c1',
    type: 'kovesecs',
  },
  {
    name: 'kov_06b',
    colors: ['#d57846', '#dfe0cc', '#de442f', '#e7d3c5', '#5ec227', '#302f35', '#63bdb3'],
    stroke: '#292319',
    background: '#dfd4c1',
    type: 'kovesecs',
  },
  {
    name: 'kov_07',
    colors: ['#c91619', '#fdecd2', '#f4a000', '#4c2653'],
    stroke: '#111',
    background: '#89c2cd',
    type: 'kovesecs',
  },
];
